/**
 * Reduce a list of vehicle assignments to at most one entry per bus number.
 * `busNumber === null` / missing entries are dropped. Preserves the order
 * of the first occurrence for each bus number.
 *
 * The DetailsHeader is only ever interested in the union of buses used by
 * the ride, not in how many segments each covers.
 *
 * @param {Array<{ busNumber?: string | null }>} vehicleAssignments
 * @returns {Array<{ busNumber: string }>}
 */
export const deriveUniqueVehicleAssignments = (vehicleAssignments = []) => {
	const seen = new Set();
	const out = [];
	for (const va of vehicleAssignments) {
		if (!va?.busNumber) continue;
		if (seen.has(va.busNumber)) continue;
		seen.add(va.busNumber);
		out.push(va);
	}
	return out;
};
